import { render, staticRenderFns } from "./addGameDisposition.vue?vue&type=template&id=3bf8b32d&"
import script from "./addGameDisposition.vue?vue&type=script&lang=js&"
export * from "./addGameDisposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bf8b32d')) {
      api.createRecord('3bf8b32d', component.options)
    } else {
      api.reload('3bf8b32d', component.options)
    }
    module.hot.accept("./addGameDisposition.vue?vue&type=template&id=3bf8b32d&", function () {
      api.rerender('3bf8b32d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/addGameDisposition.vue"
export default component.exports